import { ISubBuilderCalculatorStrings, ISubBuilderDateSettings, ISubBuilderDateStrings, ISubBuilderDurationStrings, ISubBuilderGrindStrings, ISubBuilderQuantityStrings, ISubBuilderRoutineStrings, ISubBuilderSettings } from './types'
import { camelCaseKeys } from './utils'

// Excluded dates are typed by hand in the theme editor. The help text asks for
// 'dd/mm/yyyy' but older entries used 'dd:mm:yyyy', so split on any non-digit
// and drop anything that doesn't parse to a real date.
const stringToDate = (str: string): Date | null => {
  const parts = (str || '').match(/\d+/g)
  if (!parts || parts.length < 3) return null
  const [date, month, year] = parts.map(s => parseInt(s, 10));
  const parsed = new Date(year, month - 1, date)
  return isNaN(parsed.getTime()) ? null : parsed
}

const shapeSettings = (settings: Record<string, any>): ISubBuilderSettings => {
  const giftProducts = [...settings.subProductSettings.blocks.flatMap(block => block.type === 'gift_product' ? {blockType: block.type, ...camelCaseKeys(block.settings)} : [] as null ), ...settings.subProductSettings.blocks.flatMap(block => block.type === 'gift_product_traditional' ? {blockType: block.type, ...camelCaseKeys(block.settings)} : [] as null ), ...settings.subProductSettings.blocks.flatMap(block => block.type === 'gift_product_both' ? {blockType: block.type, ...camelCaseKeys(block.settings)} : [] as null )]
  const forMeProducts = settings.subProductSettings.blocks.flatMap(block => block.type === 'non_gift_product' ? {blockType: block.type, ...camelCaseKeys(block.settings)} : [] as null)
  const productSelectionSettings = camelCaseKeys(settings.subProductSettings.settings);
  const grindStepStrings = camelCaseKeys(settings.subGrindSettings.settings)
  const grindStyles = settings.subGrindSettings.blocks.flatMap(block => block.type === 'grind_style' ? camelCaseKeys(block.settings) : [] as null)
  const routineStepStrings = camelCaseKeys(settings.subRoutineSettings.settings);
  const routineStepQuantities = [...settings.subRoutineSettings.blocks.flatMap(block => block.type === 'quantity_option' ? camelCaseKeys({...block.settings, type: block.type}) : [] as null), ...settings.subRoutineSettings.blocks.flatMap(block => block.type === 'two_x_quantity_option' ? camelCaseKeys({...block.settings, type: block.type}) : [] as null)]
  const durationStepStrings = camelCaseKeys(settings.subDurationSettings.settings);
  const durationStepQuantities = settings.subDurationSettings.blocks.flatMap(block => block.type === 'duration' ? camelCaseKeys(block.settings) : [] as null)
  const giftQuantityStrings = camelCaseKeys(settings.subQuantitySettings.settings);
  const giftQuantityOptions = [...settings.subQuantitySettings.blocks.flatMap(block => block.type === 'quantity_option' ? camelCaseKeys({...block.settings, type: block.type}) : [] as null), ...settings.subQuantitySettings.blocks.flatMap(block => block.type === 'two_x_quantity_option' ? camelCaseKeys({...block.settings, type: block.type}) : [] as null)]
  const dateSelectionSettings = camelCaseKeys(settings.subDateSelectorSettings.settings);
  
  const calcualtorStrings = camelCaseKeys(settings.subCalculatorSettings.settings);
  const caclulatorItems = settings.subCalculatorSettings.blocks.flatMap(block => block.type === 'daily_amount' ? camelCaseKeys(block.settings) : [] as null)
  const summarySettings = camelCaseKeys(settings.subSummarySettings.settings)

  const excludedDates = settings.subDateSelectorSettings.blocks.flatMap(block => block.type === 'excluded_date' ? (stringToDate(block.settings.title) || [] as null) : [] as null)

  return {
    products: {
      gift: giftProducts,
      me: forMeProducts
    },
    steps: {
      who: {
        strings: {
          title: productSelectionSettings.stepTitleWho,
          intro: productSelectionSettings.stepIntroWho,
          forMeText: productSelectionSettings.forMeText,
          giftText: productSelectionSettings.giftText
        },
        settings: {
          forMeImage: productSelectionSettings.forMeImage,
          giftImage: productSelectionSettings.giftImage,
          giftImageHover: productSelectionSettings.giftImageHover
        }
      },
      roast: {
        strings: {
          title: productSelectionSettings.stepTitleRoast,
          intro: productSelectionSettings.stepIntroRoast
        }
      },
      grind: {
        options: grindStyles,
        strings: grindStepStrings as ISubBuilderGrindStrings
      },
      routine: {
        options: routineStepQuantities,
        strings: routineStepStrings as ISubBuilderRoutineStrings
      },
      duration: {
        options: durationStepQuantities,
        strings: durationStepStrings as ISubBuilderDurationStrings
      },
      quantity: {
        options: giftQuantityOptions,
        strings: giftQuantityStrings as ISubBuilderQuantityStrings
      },
      date: {
        strings: {
          intro: dateSelectionSettings.intro,
          title: dateSelectionSettings.title
        } as ISubBuilderDateStrings,
        settings: {
          deliveryTime: Math.max(Math.floor(dateSelectionSettings.deliveryTime), 1),
          deliveryMax: Math.max(Math.floor(dateSelectionSettings.deliveryMax), 1)
        } as ISubBuilderDateSettings,
        excludedDates
      },
      calculator: {
        options: caclulatorItems,
        strings: calcualtorStrings as ISubBuilderCalculatorStrings
      },
      summary: {
        settings: {
          image: summarySettings.image,
          giftWrapMaxChars: summarySettings.giftWrapMaxChars,
          reviewLogo: summarySettings.reviewLogo,
          reviewLink: summarySettings.reviewLink
        },
        strings: {
          title: summarySettings.title,
          whoLabel: summarySettings.whoLabel,
          planLabel: summarySettings.planLabel,
          grindLabel: summarySettings.grindLabel,
          quantityLabel: summarySettings.quantityLabel,
          frequencyLabel: summarySettings.frequencyLabel,
          durationLabel: summarySettings.durationLabel,
          deliveryLabel: summarySettings.deliveryLabel,
          priceLabel: summarySettings.priceLabel,
          atcText: summarySettings.atcText,
          giftWrapLabel: summarySettings.giftWrapLabel,
          giftWrapPlaceholder: summarySettings.giftWrapPlaceholder,
          benefitsTitle: summarySettings.benefitsTitle,
          benefitsText: summarySettings.benefitsText,
          reviewTitle: summarySettings.reviewTitle,
          reviewContent: summarySettings.reviewContent,
          reviewName: summarySettings.reviewName,
          reviewRating: summarySettings.reviewRating
        }
      }
    }
  }
}


export default shapeSettings